import { ViewModel,View, ObservableArray } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { ContentPropertyType, ListPropertyType, StringPropertyType, TemplatePropertyType, TemplateSelectorPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import  { ComboView } from "./combo-view"



export class ComboComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Combo';
        this.addProperty("ItemsSource","data-b-comp-items",new ListPropertyType(this),null,false);
        this.addProperty("SelectedItem","data-b-comp-selected",new ContentPropertyType(this),null,false);
        this.addProperty("ItemTemplateSelector","data-b-comp-templateselectorfunction",new TemplateSelectorPropertyType(this),"",false);

    }

    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new ComboViewModel(parent);
        return result;
    }
        
}
export class ComboViewModel extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.ItemsSource = ObservableArray.create<ViewModel>();        
    }
    GetDefaultView(): View <ViewModel> {
        return new ComboView();
    }
    public getTypeId(): string {
        return "VM-7EE9C553-8712-405B-A486-3240F5F003BF"
    }

    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitComboBox(this,parameter);
    }

    public set ItemsSource(v: ObservableArray<ViewModel>) { this._ItemsSource = v; } public get ItemsSource(): ObservableArray<ViewModel> { return this._ItemsSource;} private _ItemsSource: ObservableArray<ViewModel>;
    public set SelectedItem(v: ViewModel) { this._SelectedItem = v; } public get SelectedItem(): ViewModel { return this._SelectedItem;} private _SelectedItem: ViewModel;
    public set TemplateSelector(v: ITemplateSelector) { this._TemplateSelector = v; } public get TemplateSelector(): ITemplateSelector { return this._TemplateSelector;} private _TemplateSelector: ITemplateSelector;
    public set ItemTemplateSelector(v: string) { this._ItemTemplateSelector = v; } public get ItemTemplateSelector(): string { return this._ItemTemplateSelector;} private _ItemTemplateSelector: string;

    override onDataContextSet(){
        super.onDataContextSet();

        this.TemplateSelector = this.DataContext._Builder_TemplateSelector__;
    }
}
